module.exports = __webpack_public_path__ + "media/application/images/svgs/social/email-c998ed6c6329ae4ec7984dcb6c7b8329.svg";